export default __webpack_public_path__ + "static/media/pin-art-center.7cdd734e.png";